import Reveal from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "A private conversation",
    body: "A call with a co-founder. We listen, ask questions, and tell you plainly whether we are the right firm for what you need. There is no charge for this conversation.",
  },
  {
    num: "02",
    title: "Family Office Strategic Discovery Session",
    body: "A structured session covering the family, the assets, the countries and the goals. It produces a written brief of what we found and what we recommend examining.",
  },
  {
    num: "03",
    title: "Fact finding",
    body: "Documents, ownership records, existing structures and adviser relationships collected and read by us, so that the design rests on what is actually there.",
  },
  {
    num: "04",
    title: "Plan design",
    body: "Our team analyses the relevant jurisdictions and returns with structuring options. Each option states its cost, its maintenance burden and its trade-offs in plain terms.",
  },
  {
    num: "05",
    title: "Plan delivery",
    body: "A review call where we walk through the recommended structure, the sequence to build it and who does what. The plan is a document you can hand to any professional.",
  },
  {
    num: "06",
    title: "Implementation and twelve months of follow up",
    body: "We coordinate the build and stay with the family for a year afterwards, checking the structure against what has changed in your life and in the law.",
  },
];

export default function HowWeWork() {
  return (
    <section className="band band-deep" id="how" data-testid="section-how">
      <div className="container">
        <Reveal>
          <div className="section-head">
            <p className="eyebrow">How we work</p>
            <div>
              <h2>Six steps from first conversation to a running office.</h2>
              <p className="lede">
                The sequence is the same for every family. The design inside
                it is not.
              </p>
            </div>
          </div>
        </Reveal>
        <div className="steps" data-testid="steps-grid">
          {STEPS.map((step, index) => (
            <Reveal key={step.num} delay={index * 0.05}>
              <article className="step" data-testid={`step-${step.num}`}>
                <span className="step-num">{step.num}</span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <p className="steps-note" data-testid="steps-note">
            Fees are discussed in the first conversation, once we understand
            the scope. They are fixed for each phase before the phase begins.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
